import { render, staticRenderFns } from "./eventsReport.vue?vue&type=template&id=017d8a0c&scoped=true"
import script from "./eventsReport.vue?vue&type=script&lang=js"
export * from "./eventsReport.vue?vue&type=script&lang=js"
import style0 from "./eventsReport.vue?vue&type=style&index=0&id=017d8a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d8a0c",
  null
  
)

export default component.exports